import { Head, Link } from '@inertiajs/react'
import Form from './form.tsx'
import type { TaxModuleType } from './types.ts'

interface NewProps {
  tax_module: TaxModuleType
}

export default function New({ tax_module }: NewProps) {
  return (
    <>
      <Head title="Nouveau module fiscal" />

      <div className="mx-auto md:w-2/3 w-full px-8 pt-8">
        <h1 className="font-bold text-4xl">Nouveau module fiscal</h1>

        <Form
          tax_module={tax_module}
          method="post"
          action="/admin/tax_modules"
          submitText="Créer un module fiscal"
        />

        <Link
          href="/admin/tax_modules"
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Retour aux modules fiscaux
        </Link>
      </div>
    </>
  )
}
